import React from 'react';
import { loginApi } from '../../api/loginApi.js';
import { useNavigate } from 'react-router-dom';
import './navBar.css'; // Import the CSS file

function NavBar() {
    const navigate = useNavigate();

    const handleHomeClick = () => {
        navigate('/home');
    }

    const handleTransactionsClick = () => {
        navigate('/transactions');
    }

    const handleUploadClick = () => {
        navigate('/upload');
    }

    const handleGraphClick = () => {
        navigate('/graph');
    }

    const handleMappingClick = () => {
        navigate('/uploadMappings');
    }

    const handleLogout = async () => {
        loginApi.logout();
        navigate('/login');
    };

    return (
        <nav className="navbar">
            <button className="nav-button" onClick={handleHomeClick}>Home</button>
            <button className="nav-button" onClick={handleTransactionsClick}>Transactions</button>
            <button className="nav-button" onClick={handleUploadClick}>Upload</button>
            <button className="nav-button" onClick={handleGraphClick}>Graphs</button>
            <button className="nav-button" onClick={handleMappingClick}>Mappings</button>
            <button className="nav-button" onClick={handleLogout}>Logout</button>
        </nav>
    )
}

export { NavBar };
